import React from "react";
import ReactGA from "react-ga";
import _ from "lodash";
import { history } from "../store";
import { getCurrentPage } from "../helpers";

class POIItem extends React.Component {
    state = {
        poiType: this.props.poiType,
        loading: false,
        checked: false,
    };

    handleChange = (event) => {
        const target = event.target;
        const value =
            target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        // GA Track
        ReactGA.event({
            category: _.startCase(getCurrentPage()),
            action: value === true ? "Show layer" : "Hide layer",
            label: name,
        });

        if (value === true) {
            this.showPOI();
        } else {
            this.hidePOI();
        }
    };

    showPOI = () => {
        this.setState(
            {
                checked: true,
            },
            () => {
                this.updateURL();
            }
        );

        const poiType = this.state.poiType;

        // Prepare lat and lng coordinates to include in POI query if bikeParking
        if (poiType === "bikeParking") {
            // All valid locations
            const locations = this.props.valid_locations;

            // Include them in the query
            if (locations.length > 0) {
                this.props.getParking(locations);

                this.setState({
                    loading: true,
                });
            }
        } else {
            this.setState({
                loading: true,
            });

            this.props.getPOI(poiType);
        }
    };

    hidePOI = () => {
        this.setState(
            {
                loading: false,
                checked: false,
            },
            () => {
                this.updateMap();
                this.updateURL();
            }
        );
    };

    // Store current POI in URL
    updateURL = () => {
        const poiType = this.state.poiType;
        const pathname = this.props.location.pathname;
        const fullQuery = this.props.location.query;
        const poiQuery = this.props.location.query.poi; // saved from user entering in form
        const poi = poiQuery ? poiQuery.split(",") : [];
        let newPOI;

        // Add or remove
        if (this.state.checked) {
            const set = new Set(poi).add(poiType);
            newPOI = Array.from(set);
        } else {
            newPOI = _.without(poi, poiType);
        }

        const query =
            newPOI.length > 0 ? newPOI.map((poi) => poi).join() : undefined;

        history.push({ pathname, query: { ...fullQuery, poi: query } });
    };

    // Get POI from URL
    getFromURL = () => {
        const poiType = this.state.poiType;
        const poiQuery = this.props.location.query.poi;
        const poi = poiQuery ? poiQuery.split(",") : [];

        if (_.find(poi, (poi) => poi === poiType)) {
            this.showPOI();
        }
    };

    updateLoading = () => {
        this.setState({
            loading: false,
        });
    };

    updateMap = () => {
        const poiType = this.state.poiType;

        if (this.props.POI.poi[poiType] && this.state.checked) {
            const results = this.props.POI.poi[poiType].results;

            if (results) {
                // Get just makers for Bike Parking (is object containing location for caching)
                let markers =
                    poiType === "bikeParking"
                        ? results.map((result) => result.markers)
                        : results.markers;
                markers = [].concat(...markers);

                const polylines = results.polylines;

                this.props.addMarkers(`poi_${poiType}`, markers);
                this.props.addPolylines(`poi_${poiType}`, polylines);
            }
        } else {
            this.props.removeMarkers(`poi_${poiType}`);
            this.props.removePolylines(`poi_${poiType}`);
        }
    };

    componentDidMount() {
        this.getFromURL();
        if (this.state.poiType === "cycleShopsAndRepairs" || this.state.poiType === "bikePumps") {
            this.showPOI(); 
        }
    }

    componentDidUpdate(prevProps) {
        const poiType = this.state.poiType;

        const newResults =
            this.props.POI.poi[poiType] !== prevProps.POI.poi[poiType];
        if (newResults) {
            this.updateLoading();
            this.updateMap();

            // POI has been cleared
            if (this.props.POI.poi[poiType] === undefined) {
                this.hidePOI();
            }
        }

        // Update parking on new locations
        const newLocations = !_.isEqual(
            this.props.valid_locations,
            prevProps.valid_locations
        );
        if (newLocations) {
            if (poiType === "bikeParking" && this.state.checked) {
                this.props.locationTidyPOI(
                    "bikeParking",
                    this.props.valid_locations
                );
                this.hidePOI();

                if (this.props.valid_locations.length > 0) {
                    this.showPOI();
                }
            }
        }
    }

    componentWillUnmount() {
        const { poiType } = this.props;

        this.props.removeMarkers(`poi_${poiType}`);
        this.props.removePolylines(`poi_${poiType}`);
    }

    render() {
        const poiType = this.state.poiType;
        let label = this.props.label;
        let checked = this.state.checked;

        // Disable parking unless valid locations
        const disabled =
            poiType === "bikeParking" && this.props.valid_locations.length === 0
                ? true
                : false;

        // Swap label text for bike parking
        if (poiType === "bikeParking" && checked === true) {
            label = "Hide Bike Parking";
        }

        return (
            <div
                className={`poi-filter-item ${poiType} isLoading-${this.state.loading} isDisabled-${disabled}`}
            >
                <input
                    name={label}
                    id={poiType}
                    type="checkbox"
                    className="condensed-checkbox"
                    onChange={this.handleChange}
                    checked={this.state.checked}
                    disabled={disabled}
                />

                <label
                    className="checkbox-label checkbox-label"
                    htmlFor={poiType}
                >
                    {label}

                    {poiType === "bikeParking" && (
                        <svg className="icon" aria-hidden="true">
                            <use xlinkHref="#bike_lock"></use>
                        </svg>
                    )}
                </label>
            </div>
        );
    }
}

// const PoiLabel = ({
// 	label,
// 	poiType,
// 	mobileLabel
// }) => {
// 	if (!mobileLabel) {
// 		return (
// 			<label className="checkbox-label" htmlFor={poiType}>{label}</label>
// 		)
// 	} else {
// 		return (
// 			<label className="checkbox-label checkbox-label--desktop" htmlFor={poiType}>
// 				{label}<span>{mobileLabel}</span>
// 			</label>
// 		)
// 	}
// };

export default POIItem;



// WEBPACK FOOTER //
// ./src/components/POIItem.js